/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AttachmentByMobile } from '../model/attachmentByMobile';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AttachmentByMobileService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Unique ID will be generated by system ad return to caller
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAttachmentByMobilePost(body?: Array<AttachmentByMobile>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiAttachmentByMobilePost(body?: Array<AttachmentByMobile>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiAttachmentByMobilePost(body?: Array<AttachmentByMobile>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiAttachmentByMobilePost(body?: Array<AttachmentByMobile>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/AttachmentByMobile`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uniqueID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAttachmentByMobilesUniqueIDGet(uniqueID: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiAttachmentByMobilesUniqueIDGet(uniqueID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiAttachmentByMobilesUniqueIDGet(uniqueID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiAttachmentByMobilesUniqueIDGet(uniqueID: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uniqueID === null || uniqueID === undefined) {
            throw new Error('Required parameter uniqueID was null or undefined when calling apiAttachmentByMobilesUniqueIDGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/AttachmentByMobiles/${encodeURIComponent(String(uniqueID))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param uniqueID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAttachmentByMobilesUniqueIDIdDownloadGet(id: number, uniqueID: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public apiAttachmentByMobilesUniqueIDIdDownloadGet(id: number, uniqueID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public apiAttachmentByMobilesUniqueIDIdDownloadGet(id: number, uniqueID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public apiAttachmentByMobilesUniqueIDIdDownloadGet(id: number, uniqueID: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiAttachmentByMobilesUniqueIDIdDownloadGet.');
        }

        if (uniqueID === null || uniqueID === undefined) {
            throw new Error('Required parameter uniqueID was null or undefined when calling apiAttachmentByMobilesUniqueIDIdDownloadGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/AttachmentByMobiles/${encodeURIComponent(String(uniqueID))}/${encodeURIComponent(String(id))}/download`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
		responseType: 'blob' as 'json',
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uniqueID 
     * @param id 
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAttachmentByMobilesUniqueIDIdUploadPut(uniqueID: string, id: number, file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiAttachmentByMobilesUniqueIDIdUploadPut(uniqueID: string, id: number, file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiAttachmentByMobilesUniqueIDIdUploadPut(uniqueID: string, id: number, file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiAttachmentByMobilesUniqueIDIdUploadPut(uniqueID: string, id: number, file?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uniqueID === null || uniqueID === undefined) {
            throw new Error('Required parameter uniqueID was null or undefined when calling apiAttachmentByMobilesUniqueIDIdUploadPut.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiAttachmentByMobilesUniqueIDIdUploadPut.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/AttachmentByMobiles/${encodeURIComponent(String(uniqueID))}/${encodeURIComponent(String(id))}/upload`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
